module.exports = __webpack_public_path__ + "img/icon_repeat_active.105c10a2.svg";